var map = {
	"./branding": 63,
	"./branding.js": 63,
	"./opalrt/img/datamodel.png": 1065,
	"./opalrt/img/eonerc_rwth.svg": 621,
	"./opalrt/img/logo_opalrt.svg": 620,
	"./opalrt/img/logo_opalrt_square.svg": 1066,
	"./opalrt/opalrt-functions": 246,
	"./opalrt/opalrt-functions.js": 246,
	"./opalrt/opalrt-values": 384,
	"./opalrt/opalrt-values.js": 384,
	"./slew/img/eonerc_rwth.svg": 617,
	"./slew/img/erigrid2.png": 618,
	"./slew/img/european_commission.svg": 619,
	"./slew/img/slew_blue.svg": 1067,
	"./slew/img/slew_logo.png": 1068,
	"./slew/img/slew_magenta.svg": 1069,
	"./slew/slew-functions": 313,
	"./slew/slew-functions.js": 313,
	"./slew/slew-values": 383,
	"./slew/slew-values.js": 383,
	"./slew/slew.css": 616,
	"./template/img/template_logo.svg": 622,
	"./template/template-functions": 247,
	"./template/template-functions.js": 247,
	"./template/template-values": 385,
	"./template/template-values.js": 385,
	"./villasweb/img/datamodel.png": 1070,
	"./villasweb/img/eonerc_rwth.svg": 611,
	"./villasweb/img/erigrid2.png": 615,
	"./villasweb/img/european_commission.svg": 466,
	"./villasweb/img/jara.svg": 1071,
	"./villasweb/img/reserve.svg": 614,
	"./villasweb/img/uel.png": 613,
	"./villasweb/img/uel_efre.jpeg": 612,
	"./villasweb/img/villas_web.svg": 610,
	"./villasweb/villasweb-functions": 202,
	"./villasweb/villasweb-functions.js": 202,
	"./villasweb/villasweb-values": 312,
	"./villasweb/villasweb-values.js": 312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1064;